import { useCurrentUser } from '../../../contexts/UserContext';
import { useCoursesByRole } from '../../../hooks/useCourses';

export default function MyCourses() {
  const currentUser = useCurrentUser();
  const { items: enrollments, loading, error } = useCoursesByRole(currentUser);

  return (
    <div className="widget-card">
      <div className="info-card-header">
        <p className="eyebrow">My courses</p>
        <span className="badge neutral">{enrollments.length}</span>
      </div>
      <div className="course-list course-list-compact">
        {loading && <p className="muted-text">Loading courses…</p>}
        {!loading && error && <p className="error-text">{error}</p>}
        {!loading && !error && enrollments.length === 0 && (
          <p className="muted-text">No courses assigned yet.</p>
        )}
        {!loading &&
          !error &&
          enrollments.map((enrollment) => {
            const course = enrollment.course || {};
            const title = course.title || course.code || 'Course';
            const subtitle = course.grade
              ? `Grade ${course.grade} · ${course.subject || ''}`
              : course.subject || '—';
            const progressPercent =
              typeof enrollment.progress === 'number' ? enrollment.progress : 0;
            const filledBlocks = Math.max(0, Math.min(10, Math.round(progressPercent / 10)));
            return (
              <div key={enrollment.id || title} className="course-row">
                <div>
                  <p className="course-title info-title">{title}</p>
                  <p className="muted-text">{subtitle}</p>
                </div>
                <div
                  className="course-progress"
                  aria-label={`${title} progress ${Math.round(progressPercent)} percent`}
                >
                  {Array.from({ length: 10 }, (_, index) => (
                    <span
                      key={index}
                      className={`progress-block ${index < filledBlocks ? 'filled' : ''}`}
                      aria-hidden="true"
                    />
                  ))}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
